import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUserData, clearUserData } from '../redux/userSlice';
import { getUserAccess, getUserByToken } from '../services/projectReportServices';

export const useCurrentUserAccess = (nikFromUrl) => {
  const dispatch = useDispatch();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const fetchAuth = async () => {
      // Bersihkan Redux state agar tidak ada sisa data lama
      dispatch(clearUserData());

      try {
        let token = localStorage.getItem('token');
        // Jika token ada, baru lakukan replace. Jika tidak (karena iframe), biarkan null/undefined.
        if (token) {
          token = token.replace(/"/g, '');
        }

        let currentNik = nikFromUrl;

        // Coba ambil dari URL parameter jika belum ada
        if (!currentNik) {
          const searchParams = new URLSearchParams(window.location.search);
          currentNik = searchParams.get('nik');
        }

        // Coba dapatkan dari token jika masih belum ada (dan tokennya memang ada)
        if (!currentNik && token) {
          const userRes = await getUserByToken(token);
          currentNik = userRes?.data?.nik;
        }

        if (currentNik) {
          const accessRes = await getUserAccess(currentNik);
          dispatch(setUserData({
            name: accessRes.data.name,
            permission: accessRes.data.permissions
          }));
        }
      } catch (error) {
        console.error('Error fetching user access (Helper):', error);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    fetchAuth();
  }, [dispatch, nikFromUrl]);

  return { isCheckingAuth };
};
